var fixedContent = {
    DOM: {
        target: null,
    },

    cacheDOM: function () {
        fixedContent.DOM.targetContainer = document.querySelectorAll('.--scroll');
    },

    events: {
        scroll: function (callback) {
            window.addEventListener('scroll', callback, { passive: true });
        },
    },

    actions: {
        isInViewport: function (el) {
            var rect = el.getBoundingClientRect();
            var myElementHeight = el.offsetHeight;
            var myElementWidth = el.offsetWidth;

            return (
                rect.top >= -myElementHeight &&
                rect.left >= -myElementWidth &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight
            );
        },

        isColliding: function (div1, div2) {
            var d1Offset = div1.getBoundingClientRect();
            var d1Height = div1.getBoundingClientRect().height;
            var d1Width = div1.getBoundingClientRect().width;
            var d1Top = d1Offset.top + d1Height;
            var d1Left = d1Offset.left + d1Width;

            var d2Offset = div2.getBoundingClientRect();
            var d2Height = div2.getBoundingClientRect().height;
            var d2Width = div2.getBoundingClientRect().width;
            var d2Top = d2Offset.top + d2Height;
            var d2Left = d2Offset.left + d2Width;

            return !(d1Top < d2Offset.top || d1Offset.top > d2Top || d1Left < d2Offset.left || d1Offset.left > d2Left);
        },

        checkScreen: function () {
            if (window.innerWidth > 1080) {
                return true;
            }
            return false;
        },
    },

    init: function () {
        if (this.actions.checkScreen() === false) {
            return;
        }

        this.cacheDOM();
        var currentBanner = null;
        var parent = null;
        var children = null;

        this.events.scroll(function () {
            for (var i = 0; i < fixedContent.DOM.targetContainer.length; i++) {
                currentBanner = fixedContent.DOM.targetContainer[i].querySelector('[id*=div-gpt-ad]:first-child');

                if (
                    fixedContent.actions.isInViewport(currentBanner) &&
                    fixedContent.actions.isColliding(currentBanner, fixedContent.DOM.targetContainer[i]) &&
                    currentBanner.getBoundingClientRect().top < 0
                ) {
                    parent = fixedContent.DOM.targetContainer[i];
                    children = parent.querySelector('[id*=div-gpt-ad]:first-child');
                }
            }

            if (
                parent === null ||
                children === null ||
                parent.getBoundingClientRect().height <= children.getBoundingClientRect().height
            ) {
                return;
            }

            var parentRect = parent.getBoundingClientRect();
            var childrenRect = currentBanner.getBoundingClientRect();
            var childBottomOffset = parentRect.bottom - childrenRect.height;
            var childrenTopOffset = childBottomOffset + childrenRect.height;

            if (childrenTopOffset >= parentRect.height) {
                children.style.position = 'absolute';
                children.style.bottom = 'auto';
                children.style.top = 0;
            } else if (childBottomOffset <= 0) {
                children.style.position = 'absolute';
                children.style.bottom = 0;
                children.style.top = 'auto';
            } else if (parentRect.top <= 0) {
                children.style.position = 'fixed';
                children.style.bottom = 'auto';
                children.style.top = 10 + 'px';
            }
        });
    },
};

window.addEventListener('load', function () {
    return fixedContent.init();
});
